import { render } from "./FieldVitalityCheckOilseedRapeIcon.vue?vue&type=template&id=fd4b2ba0"
import script from "./FieldVitalityCheckOilseedRapeIcon.vue?vue&type=script&lang=js"
export * from "./FieldVitalityCheckOilseedRapeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__